import { render } from "./RankingModal.vue?vue&type=template&id=b7aa6892&scoped=true"
import script from "./RankingModal.vue?vue&type=script&lang=js"
export * from "./RankingModal.vue?vue&type=script&lang=js"

import "./RankingModal.vue?vue&type=style&index=0&id=b7aa6892&scoped=true&lang=css"

import exportComponent from "/var/www/hutch/quizgiri/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7aa6892"]])

export default __exports__